import { render, staticRenderFns } from "./C2wCampaignsTable.vue?vue&type=template&id=b6c1a69e&scoped=true&"
import script from "./C2wCampaignsTable.vue?vue&type=script&lang=js&"
export * from "./C2wCampaignsTable.vue?vue&type=script&lang=js&"
import style0 from "./C2wCampaignsTable.vue?vue&type=style&index=0&id=b6c1a69e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6c1a69e",
  null
  
)

export default component.exports